// Stub notification slice
import { createSlice } from "@reduxjs/toolkit";

const notificationSlice = createSlice({
  name: "notification",
  initialState: { notifications: [], unread: 0 },
  reducers: {
    clearNotification: (state) => {
      state.notifications = [];
      state.unread = 0;
    },
  },
});

export const { clearNotification } = notificationSlice.actions;
export default notificationSlice.reducer;
